import { AnchorAPI } from '../AnchorAPI';
import { localStorage } from '../Browser/localStorage';

const FEATURE_FLAGS = {
  SPOTIFY_VIDEO_PODCAST_ENABLED: 'spotifyVideoPodcastEnabled',
  STREAMING_AD_INSERTION_ENABLED: 'streamingAdInsertionEnabled',
  MUSIC_AND_TALK_ENABLED: 'isMusicAndTalkEnabled',
};
const FEATURE_FLAG_KEY = 'featureFlags';

export type FeatureFlag =
  | typeof FEATURE_FLAGS.SPOTIFY_VIDEO_PODCAST_ENABLED
  | typeof FEATURE_FLAGS.STREAMING_AD_INSERTION_ENABLED
  | typeof FEATURE_FLAGS.MUSIC_AND_TALK_ENABLED;

function getIsSaiOrVodcast(featureFlags?: FeatureFlag[]) {
  return featureFlags
    ? featureFlags.includes(FEATURE_FLAGS.SPOTIFY_VIDEO_PODCAST_ENABLED) ||
        featureFlags.includes(FEATURE_FLAGS.STREAMING_AD_INSERTION_ENABLED)
    : false;
}

/**
 * Sets feature flags in browser storage. If you pass an argument, it will set
 * that value as the feature flag. Otherwise, it will fetch the current user's
 * feature flags and sets them in browser storage
 * @param newFeatureFlags
 */
async function setFeatureFlagsIndexedDb(
  newFeatureFlags?: FeatureFlag[] | null
) {
  try {
    let featureFlags = newFeatureFlags;
    let error;
    if (featureFlags === undefined) {
      const {
        json,
        error: fetchError,
      } = await AnchorAPI.fetchAllEnabledFeatureFlags();
      if (json) {
        featureFlags = json.allEnabledFlags.map(({ name }) => name);
      }
      error = fetchError;
    }
    localStorage.setItem(FEATURE_FLAG_KEY, featureFlags);
    return { error, featureFlags };
  } catch (err) {
    throw new Error(err.message);
  }
}

export {
  getIsSaiOrVodcast,
  FEATURE_FLAGS,
  setFeatureFlagsIndexedDb,
  FEATURE_FLAG_KEY,
};
